import { render, staticRenderFns } from "./QuestionDetail.vue?vue&type=template&id=24f6b094&scoped=true"
import script from "./QuestionDetail.vue?vue&type=script&lang=js"
export * from "./QuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./QuestionDetail.vue?vue&type=style&index=0&id=24f6b094&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24f6b094",
  null
  
)

export default component.exports